import WAValidator from 'wallet-address-validator'
import { isBech32BitcoinAddress } from './bech32_btc'

export function validateAddress (address, asset = 'ETH') {
  if (isETHAddress(address)) return true
  if (isBTCAddress(address)) return true
  if (isTaurusAddress(address)) return true
  return false
}

function isETHAddress (address) {
  return /^(0x)?[0-9a-f]{40}$/i.test(address)
}

function isBTCAddress (address) {
  // Legacy base58 (1…/3…, m/n/2… on testnet) via the library, native SegWit
  // and Taproot (bc1…/tb1…) via the in-house bech32 check: the library
  // version in use predates BIP173 and rejects every bech32 address.
  return WAValidator.validate(address, 'BTC', 'both') || isBech32BitcoinAddress(address)
}

function isTaurusAddress (address) {
  if (address.length > 6 && (/[0-9]$/i.test(address))) {
    let i = parseInt(address, 10)
    let maxUint = (1 << 32)
    return (i > 999999 && i < maxUint)
  }
  return false
}



// WEBPACK FOOTER //
// ./src/validator/address_validation.js